import { ChangeDetectionStrategy, Component, Input, OnChanges, SimpleChanges } from '@angular/core';
import { NotebookVizResult } from '@mode/notebooks/domain';

@Component({
  selector: 'mode-notebook-cell-warning',
  templateUrl: './notebook-cell-warning.component.html',
  styleUrls: ['./notebook-cell-warning.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class NotebookCellWarningComponent implements OnChanges {
  @Input()
  cells!: Array<NotebookVizResult>;

  public filteredResults: Array<NotebookVizResult> = [];
  public showWarnings = false;

  constructor() {}

  ngOnChanges(changes: SimpleChanges) {
    if (changes && changes['cells']) {
      this.filteredResults = (changes['cells'].currentValue as Array<NotebookVizResult>).filter(
        (r) => r.result_type === 'stderr'
      );
    }
  }
}
